import { render } from "./signUpInfo.vue?vue&type=template&id=7728bb0a"
import script from "./signUpInfo.vue?vue&type=script&lang=js"
export * from "./signUpInfo.vue?vue&type=script&lang=js"

import "./signUpInfo.vue?vue&type=style&index=0&id=7728bb0a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__